import React from 'react'
import * as styles from './style.module.scss'

export const SectionTitle = ({ children, id }) => {
	return <div className={styles.title} id={id}>{children}</div>
}
